import { Box, Typography, Button, Stack, Container, IconButton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDevice } from '../../hooks/useResponsive';
import { getInspectionBookingDetails } from '../../server/api/inspectionBooking';

export default function PayLaterSuccess() {
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const params = useParams();
  const dispatch = useDispatch();

  const { inspectionBookingSingleViewDetails } = useSelector((state) => ({
    inspectionBookingSingleViewDetails: state.Inspection.inspectionBookingSingleViewDetails,
    loading: state.Inspection.loading,
  }));

  useEffect(() => {
    const credentials = {
      bookingId: params?.id,
      dispatch,
    };
    dispatch(getInspectionBookingDetails(credentials));
  }, [dispatch, params?.id]);

  return (
    <Box className="bg-light ">
      <Container
        maxWidth="xl"
        sx={{
          padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
          position: 'relative',
          minHeight: !isMobile && '100vh',
          backgroundColor: '#f0f1f3',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: isMobile ? 150 : 500,
            backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <Container
          maxWidth="md"
          sx={{
            position: 'absolute',
            top: isMobile ? 0 : '15%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderRadius: isMobile ? 0 : '24px',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            p: isMobile ? 0 : '30px !important',
            pb: 4,
          }}
        >
          {!isMobile && (
            <Stack
              direction="row"
              alignItems="left"
              onClick={() => navigate(-1)}
              spacing={isMobile ? 0.5 : 1.2}
              sx={{ cursor: 'pointer' }}
              width="100%"
            >
              <IconButton size="small" sx={{ p: 0 }}>
                <ArrowBackIosNewIcon sx={{ fontSize: '12px', color: '#121212' }} />
              </IconButton>
              <Typography fontSize={14} fontWeight={500} color="#121212">
                Back
              </Typography>
            </Stack>
          )}
          <Box
            sx={{
              maxWidth: '500px',
              width: isMobile ? '100%' : '100%',
              minHeight: {
                xs: '75vh', // mobile
                sm: '600px', // tablet
                md: '500px', // desktop
              },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              textAlign: 'center',
              backgroundColor: 'white',

              p: 2,
            }}
          >
            <Stack alignItem="center">
              {/* Tick Image */}
              <Box
                component="img"
                src="/assets/images/Inspection/check.png"
                alt="Booking Confirmed"
                sx={{ width: 240, height: 240, mb: 2 }}
              />
              {/* Title */}
              <Typography
                fontSize={24}
                sx={{
                  fontWeight: 600,
                  color: '#7CC38D', // Green
                  mb: 1,
                }}
              >
                Booking Confirmed
              </Typography>

              {/* Subtitle */}
              <Typography fontSize={14} sx={{ color: '#121212' }}>
                Your booking for {inspectionBookingSingleViewDetails?.vehicle_details?.brand?.name || '---'} has
                confirmed.
              </Typography>
            </Stack>

            {/* Booking ID */}
            <Typography fontSize={14} sx={{ color: '#121212', fontWeight: 400 }}>
              Booking ID :{' '}
              <Box
                component="span"
                sx={{
                  textDecoration: 'underline',
                  textDecorationStyle: 'wavy',
                  textDecorationColor: '#80B9FF',
                }}
              >
                {inspectionBookingSingleViewDetails?.booking_id || '---'}
              </Box>
            </Typography>

            {/* Go Back Button */}
            <Button
              variant="outlined"
              onClick={() => navigate('/inspection-booking')}
              sx={{
                borderRadius: '50px',
                borderColor: '#F16400',
                color: '#F16400',
                px: 6,
                py: 1,
                fontWeight: 600,
                textTransform: 'none',
                width: isMobile ? '100%' : '50%',
                '&:hover': {
                  borderColor: '#F16400',
                  backgroundColor: 'rgba(255,153,16,0.05)',
                },
              }}
            >
              Go Back
            </Button>
          </Box>
        </Container>
      </Container>
    </Box>
  );
}
